import React, { useEffect, useState } from "react";
import axios from "axios";

const testURL = process.env.REACT_APP_TEST_URL;
const productionURL = process.env.REACT_APP_PRODUCTION_URL;
const Stats = () => {
  const [stats, setStats] = useState({
    totalTickets: 0,
    totalOpenTicket: 0,
    totalProcessingTicket: 0,
    totalClosedTicket: 0,
  });

  useEffect(() => {
    axios.get(productionURL + "/api/ondc/getIssueDetails")
      .then((response) => {
        setStats({
          totalTickets: response.data.totalTickets,
          totalOpenTicket: response.data.totalOpenTicket,
          totalProcessingTicket: response.data.totalProcessingTicket,
          totalClosedTicket: response.data.totalClosedTicket,
        });
      })
      .catch((error) => {
        console.error("Error fetching stats:", error);
      });
  }, []);

  return (
    <div className="stats">
      <div className="stat-box">
        <h3>Total Tickets</h3>
        <p>{stats.totalTickets}</p>
      </div>
      <div className="stat-box">
        <h3>Open Tickets</h3>
        <p>{stats.totalOpenTicket}</p>
      </div>
      <div className="stat-box">
        <h3>Processing Tickets</h3>
        <p>{stats.totalProcessingTicket}</p>
      </div>
      <div className="stat-box">
        <h3>Closed Tickets</h3>
        <p>{stats.totalClosedTicket}</p>
      </div>
    </div>
  );
};

export default Stats;
